/* @flow */
import React, { useState } from "react";
import styled from "styled-components";
import Gettext from "./common/Gettext";
import ErrorIcon from "./Icons/Error";

const Screen = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 40px;
  text-align: center;
  color: #fff;
  background-color: ${props => props.theme.main};
  background-size: cover;
  overflow: auto;
`;

const Text = styled.div`
  direction: ${props => props.theme.direction};
  width: 100%;
  max-width: 500px;
  margin: 0 auto 40px;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.3;
  text-align: center;
  color: ${props => props.theme.accent};

  @media (max-width: 959px) {
    padding: 0 30px;
    font-size: 18px;
  }
`;

const Icon = styled.div`
  width: 50px;
  height: 50px;
  margin: 0 auto 20px;
`;

const ButtonsWrapper = styled.div``;

const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0;
`;

const ErrorPre = styled.pre`
  text-align: left;
  font-family: monospace;
  max-width: 100%;
`;

const Button = styled.div`
  display: inline-block;
  height: 2.611em;
  line-height: 2.611em;
  margin-left: 0.556em;
  padding: 0 0.944em;
  font-weight: 700;
  font-size: 20px;
  color: ${props => props.theme.accent};
  border-radius: 0.5em;
  border: 1px solid ${props => props.theme.accent};
  cursor: pointer;
  transition: .5s;
  :hover,
  :focus,
  :active {
    background-color: ${props => props.theme.accent};
    color: #fff;
  }

  @media (max-width: 959px) {
    font-size: 18px;
  }
`;

function FailureScreen(props: Props) {
  const [showError, setShowError] = useState(false);
  const { errors } = props;

  return (
    <Screen>
      <Icon>
        <ErrorIcon width="100%" fill="#D75A4A" />
      </Icon>
      <Text>
        <Gettext>
          Sorry, something went wrong on our end. Please try refreshing this
          page.
        </Gettext>
      </Text>

      <ButtonsWrapper>
        <Button
          onClick={event => {
            event.stopPropagation();
            window.location.reload();
          }}
        >
          <Gettext>Refresh</Gettext>
        </Button>
        <Button onClick={() => setShowError(!showError)}>
          {!showError ? (
            <Gettext>Show error</Gettext>
          ) : (
            <Gettext>Hide error</Gettext>
          )}
        </Button>
      </ButtonsWrapper>

      {showError && (
        <ErrorWrapper>
          <ErrorPre>{errors}</ErrorPre>
        </ErrorWrapper>
      )}
    </Screen>
  );
}

export default FailureScreen;



// WEBPACK FOOTER //
// ./src/components/FailureScreen.js